function addPlaceholderToEditorParagraphs() {
    const editor = document.getElementById('johannesEditor');
    if (!editor) return;
  
    const elements = editor.querySelectorAll('p.johannes-content-element');
  
    elements.forEach((el) => {
      el.setAttribute('data-placeholder', 'Start typing...');
    });
  }